/**
 * B_Text.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define';

const B_Text = (function(superclass){

	class B_Text extends superclass {

		constructor(obj) {
			super(obj);
			// console.log(obj);

			// [E]
			if(typeof obj.text == 'undefined')  obj.text = "";
			if(typeof obj.size == 'undefined')  obj.size = 10;
			if(typeof obj.color == 'undefined') obj.color = "black";
			if(typeof obj.font == 'undefined')  obj.font = "Arial";
			if(typeof obj.style == 'undefined') obj.style = "";      else obj.style += " ";
			if(typeof obj.align == 'undefined') obj.align = "left";
			if(typeof obj.lineHeight == 'undefined') obj.lineHeight = 0;

			// [S] strResType
			this._strResType = B_Define.ARR_RES_TYPE[4];

			// [S] text
			this._object =
				new createjs.Text(
					obj.text, // [#] text
					obj.style + obj.size + "px " + obj.font, // [#] font
					obj.color // [#] color
				);
			this._object.textAlign = obj.align; // [#] align
			this._object.lineHeight = obj.lineHeight; // [#] lineHeight
			this._container.addChild(this._object);

		}

		// [V]

		// @OVERRIDING
		_setArea() { /*...*/ }

		// @OVERRIDING
		_setPoint(px, py) {
			if(super._checkReg(px, py)) {
				this._object.regX = this._object.getBounds().width * this._pointX / 100;
				this._object.regY = this._object.getBounds().height * this._pointY / 100;
			}
		}

	}

	return B_Text;
});

export default B_Text;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/text/B_Text.js